import Router from '@/router'
import http from './http'

export default {
    //退出登录
    logout() {
        localStorage.clear();
        // window.localStorage.removeItem('token')
        Router.push({path:'/login',query:{}});
    },
}


// WEBPACK FOOTER //
// ./src/utils/utils.js